// Cookie consent (analytics only — no ads): Google Consent Mode v2 + PostHog opt-in. Choice stored 6 months.
const KEY = 'cookieConsent';
const TTL_DAYS = 180;
const EVENT = 'cookie-consent-changed';

const read = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    if (!c || !c.at || Date.now() - c.at > TTL_DAYS * 86400000) return null;
    return c;
  } catch { return null; }
};

const gtag = (...args) => { if (typeof window.gtag === 'function') window.gtag(...args); };

const applyAnalytics = (granted) => {
  gtag('consent', 'update', { analytics_storage: granted ? 'granted' : 'denied' });
  const ph = window.posthog;
  if (ph && typeof ph.opt_in_capturing === 'function') {
    if (granted) { if (!ph.has_opted_in_capturing?.()) ph.opt_in_capturing(); }
    else if (!ph.has_opted_out_capturing?.()) ph.opt_out_capturing();
  }
};

export const consent = {
  get: read,
  analytics: () => !!read()?.analytics,
  decided: () => !!read(),
  set: (analytics) => {
    const c = { analytics: !!analytics, at: Date.now(), version: 1 };
    localStorage.setItem(KEY, JSON.stringify(c));
    applyAnalytics(c.analytics);
    window.dispatchEvent(new CustomEvent(EVENT, { detail: c }));
    return c;
  },
  reset: () => { localStorage.removeItem(KEY); window.dispatchEvent(new CustomEvent(EVENT, { detail: null })); },
  subscribe: (fn) => { window.addEventListener(EVENT, fn); return () => window.removeEventListener(EVENT, fn); },
  // Called once at startup: re-applies a stored choice (PostHog opts out by default, gtag defaults to denied in /js/gtag.js)
  init: () => { const c = read(); if (c) applyAnalytics(c.analytics); },
  open: () => window.dispatchEvent(new CustomEvent('cookie-consent-open')),
};
